import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Async from 'react-select/async';
import { datalayer } from '../../utils/appWrapper';
import LabelBadges from '../LabelBadges';

function LabelInput({ name, value, onChange, disabled, sessionUser }) {
  if (disabled) return <LabelBadges key={name} value={value} />;

  const [labelData, setLabelData] = React.useState({
    rows: [],
    total: 0,
    page: 0,
    totalPages: 0,
    hasMore: true,
  });

  useEffect(() => {
    let isLoading = false;
    async function getLabelData() {
      isLoading = true;
      const data = await datalayer.label.list({ page: labelData.page + 1 });
      setLabelData({
        rows: [...labelData.rows, ...data.rows],
        total: data.total,
        page: data.page,
        totalPages: data.totalPages,
        hasMore: data.page < data.totalPages,
      });
      isLoading = false;
    }

    if (labelData.hasMore && !isLoading) {
      getLabelData();
    }
  }, [labelData]);

  const handleChange = label => {
    onChange(name, {
      contains: label.map(x => ({
        id: x.value.id,
      })),
    });
  };

  const getLabelName = label => {
    if (sessionUser.roles === 'super') {
      return `${label.name} - ${
        label.owningSupplierOrganizationId
          ? label.owningSupplierOrganizationId
          : 'Flaivy Etikett'
      }`;
    }
    return label.name;
  };

  let selectedLabels = [];

  if (!value || !value.contains) {
    selectedLabels = [];
  } else {
    selectedLabels = labelData.rows.filter(label =>
      value.contains.some(val => val.id === label.id),
    );
  }

  const selectValue =
    !_.isEmpty(value) &&
    selectedLabels.map(x => ({ value: x, label: getLabelName(x) }));

  const currentOptions = labelData.rows.map(x => ({
    value: x,
    label: getLabelName(x),
  }));

  return (
    <Async
      defaultOptions={currentOptions}
      isMulti
      name={name}
      onChange={handleChange}
      value={selectValue}
      loadOptions={(inputValue, callback) => {
        const filteredOptions = currentOptions.filter(option =>
          option.label.toLowerCase().includes(inputValue.toLowerCase()),
        );
        callback(filteredOptions);
      }}
    />
  );
}

LabelInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

LabelInput.defaultProps = {
  value: [],
  disabled: false,
};

const mapStateToProps = ({ authentication }) => ({
  sessionUser: authentication.sessionUser,
});
export default connect(mapStateToProps)(LabelInput);
